import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import useStock from "../../hooks/useStock";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

import { useUser } from "../../hooks/useUser";


export default function AddorUpdate() {
  let { vendor_product_id } = useParams();
  const navigate = useNavigate();          
  const handledSuccessRef = useRef(false);
  const [ignoreExpiry, setIgnoreExpiry] = useState(false);
  const [formData, setFormData] = useState({
    vendor_product_id: vendor_product_id || 0,
    productName: "",
    vendor_id: 0,
    product_id: 0,
    category_id: 0,
    sku_id: "",
    booking_quantity: "",
    quantity: "",
    baseprice: 0.0,
    commission: 0.0,
    mfd_date: "",
    exp_date: "",
    ignore_expiry: false,
    tax_value: 0.0,
  });

  const [loggedInUser, setLoggedInUser] = useState(null);
  const stock = useStock();
  const [productsKey, setProductsKey] = useState(0);

const vendorId = Number(formData.vendor_id) || null;
  const {
    mutate: addstockMutate,
    isSuccess: addstockIsSuccess,
    isError: addstockIsError,
    error: addstockError,
    isPending: addstockIsPending,
  } = stock.addStock();

  const { data: vendorsResult, isLoading: loadingVendors } = stock.getvendor();
  const { data: categoryResult, isLoading: loadingCategory } =
    stock.getcategory();
 const { data: productResult, isLoading: Loadingproduct } =
  stock.getproducts(vendorId, productsKey);


  // ✅ Remove Foods category products from product dropdown
const filteredProducts = (productResult?.data ?? []).filter((p) => {
  const catName = (p.category_name || "").toLowerCase().trim();

  // if API gives category_name
  if (catName === "foods") return false;

  // if API gives category_id (foods=2)
  if (String(p.category_id) === "2") return false;

  return true;
});


  const {
    data: vendorProductResult,
    isLoading: vendorProductLoading,
    refetch: refetchvendorProduct,
  } = stock.getproVariable(formData.product_id, formData.vendor_id);

  useEffect(() => {
    if (!vendorProductLoading) {
      console.log(vendorProductResult);
    }
  }, [vendorProductResult]);
  const validSkus = (vendorProductResult?.data ?? []).filter(
  (x) => x?.sku_id && x?.productvariable?.variable_name
);


  useEffect(() => {
    if (formData.product_id && formData.vendor_id) {
      refetchvendorProduct();
    }
  }, [formData.product_id, formData.vendor_id]);

  const [category, setCategory] = useState([]);
 useEffect(() => {
  const list = productResult?.data ?? [];
  let temp = list.map((item) => ({
    product_id: item.product_id,
    category_id: item.category_id,
  }));
  setCategory(temp);
}, [productResult]);


 
  const { data: user, isLoading: userIsLoading } = useUser();
useEffect(() => {
  if (!userIsLoading && user) {
    setLoggedInUser(user);

    if (user.role === "vendor") {
      const vid = Number(user?.user_id || 0);

      setFormData((prev) => ({
        ...prev,
        vendor_id: vid,
        vendorName: user.name,
        product_id: 0,
        category_id: 0,
        sku_id: "",
        vendor_product_id: 0,
      }));
    }
  }
}, [userIsLoading, user]);

const handleInputChange = (e) => {
  const { name, value } = e.target;

  // vendor change -> reset
  if (name === "vendor_id") {
    setFormData((prev) => ({
      ...prev,
      vendor_id: value,
      product_id: 0,
      category_id: 0,
      sku_id: "",
      vendor_product_id: 0,
    }));
    return;
  }

  // ALWAYS: quantity -> booking_quantity auto fill
  if (name === "quantity") {
    const cleaned = value === "" ? "" : String(Number(value)); // 01 -> 1

    setFormData((prev) => ({
      ...prev,
      quantity: cleaned,
      booking_quantity: cleaned, 
    }));
    return;
  }

  // booking_quantity manual edit (optional)
  if (name === "booking_quantity") {
    const cleaned = value === "" ? "" : String(Number(value));
    setFormData((prev) => ({ ...prev, booking_quantity: cleaned }));
    return;
  }

  // default
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
  if (
    name === "sku_id" &&
    !vendorProductLoading &&
    vendorProductResult?.data?.length > 0
  ) {
    const selectItem = vendorProductResult?.data?.find(
      (item) => item.sku_id === value
    );

    setFormData((prev) => ({
      ...prev,
      sku_id: value,
      vendor_product_id: selectItem?.vendor_product_id ?? prev.vendor_product_id,
    }));
    return;
  }

  // product_id -> set category_id
  if (name === "product_id") {
    category.forEach((item) => {
      if (item.product_id === Number(value)) {
        setFormData((prev) => ({
          ...prev,
          category_id: item?.category_id ?? prev.category_id,
        }));
      }
    });

    refetchvendorProduct();
  }
};



  const handleSubmit = (e) => {
    e.preventDefault();

    const submitData = {
      vendor_product_id: formData.vendor_product_id,
      vendor_id: formData.vendor_id,
      product_id: formData.product_id,
      category_id: formData.category_id,
      sku_id: formData.sku_id,
      booking_quantity: formData.booking_quantity,
      quantity: formData.quantity,
      commission: formData.commission,
      mfd_date:
        formData.category_id !== "2" && !ignoreExpiry
          ? formData.mfd_date
          : null,
      exp_date:
        formData.category_id !== "2" && !ignoreExpiry
          ? formData.exp_date
          : null,
      ignore_expiry: ignoreExpiry,
    };

addstockMutate(submitData);
  };

  const today = new Date().toISOString().split("T")[0];

 useEffect(() => {
  // SUCCESS – only once
  if (addstockIsSuccess && !handledSuccessRef.current) {
    handledSuccessRef.current = true;

    toast.success("Stock added successfully!", {
onClose: () => {
      if (user?.role === "vendor") {
        navigate("/product");
      } else {
        navigate(`/product?vendor_id=${formData.vendor_id}`);
      }

      },
    });
  }

  // ERROR
  if (addstockIsError) {
    toast.error(addstockError?.message || "Failed to add stock!");
    handledSuccessRef.current = false; // allow retry
  }
}, [addstockIsSuccess, addstockIsError, addstockError, navigate]);

  return (
     <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="mb-4">
            <h2 className="fw-bold">Stock Information</h2>
          </div>
          
          <form
            className="theme-form theme-form-2 mega-form"
            onSubmit={handleSubmit}
          >
                    {/* Vendor Name */}
                    <div className="mb-4 row align-items-center">
                      <label className="form-label-title col-sm-3 mb-0">
                        Vendor Name
                      </label>
                      <div className="col-sm-9">
                        {loggedInUser?.role === "vendor" ? (
                          <input
                            type="text"
                            className="form-control"
                            value={formData.vendorName}
                            readOnly
                            style={{ border: "2px solid #0da486b9" }}
                          />
                        ) : loadingVendors ? (
                          <div className="text-center">Loading vendors...</div>
                        ) : (
                          <select
                            className="form-select"
                            name="vendor_id"
                            value={formData.vendor_id}
                            onChange={handleInputChange}
                            required
                            style={{ border: "2px solid #0da486b9" }}
                          >
                            <option selected disabled value="0">
                              Select a vendor
                            </option>
                            {vendorsResult?.data?.map((vendor, index) => (
                              <option key={index} value={vendor.vendor_id}>
                                {vendor.user.name}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </div>

                    {/* Product Name */}
                    <div className="mb-4 row align-items-center">
                      <label className="form-label-title col-sm-3 mb-0">
                        Stock Product Name
                      </label>
                      <div className="col-sm-9">
                        {Loadingproduct ? (
                          <div className="text-center">Loading...</div>
                        ) : (
                          <select
                           key={vendorId}
                            className="form-select"
                            name="product_id"
                            value={formData.product_id}
                            onChange={handleInputChange}
                            required
                            style={{ border: "2px solid #0da486b9" }}
                          >
                            <option selected disabled value="0">
                              Select a product
                            </option>
                          {productResult?.data
  ?.filter((product) => {
    if ((product.category_name || "").toLowerCase().trim() === "foods") {
      return false;
    }
    if (String(product.category_id) === "2") {
      return false;
    }
    return true;
  })
  .map((product) => (
    <option key={product.product_id} value={product.product_id}>
      {product.product_name}
    </option>
  ))}

                          </select>
                        )}
                      </div>
                    </div>

                    {/* Category */}
                    <div className="mb-4 row align-items-center">
                      <label className="form-label-title col-sm-3 mb-0">
                        Category
                      </label>
                      <div className="col-sm-9">
                        {loadingCategory ? (
                          <div className="text-center">Loading...</div>
                        ) : (
                          <select
                            className="form-select"
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleInputChange}
                            required
                            style={{ border: "2px solid #0da486b9" }}
                          >
                            <option selected disabled value="0">
                              Select a category
                            </option>
                              {categoryResult?.data
                                ?.filter((c) => (c.category_name || "").toLowerCase() !== "foods")
                                .map((category) => (
                                  <option
                                    key={category.category_id}
                                    value={category.category_id}
                                  >
                                    {category.category_name}
                                  </option>
                                ))}
                          </select>
                        )}
                      </div>
                    </div>

                   {/* SKU */}
                  {/* SKU (show only if valid variants exist) */}
                  {!vendorProductLoading && validSkus.length > 0 && (
                    <div className="mb-4 row align-items-center">
                      <label className="form-label-title col-sm-3 mb-0">
                        Product variable
                      </label>
                      <div className="col-sm-9">
                        <select
                          name="sku_id"
                          onChange={handleInputChange}
                          value={formData.sku_id}
                          className="form-select"
                          required
                          style={{ border: "2px solid #0da486b9" }}
                        >
                          <option disabled value="">
                            Select SKU
                          </option>
                          {validSkus.map((sku) => (
                            <option key={sku.sku_id} value={sku.sku_id}>
                              {sku.productvariable.variable_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                    {/* Ignore Expiry */}
                    {formData.category_id !== "2" && (
                      <>
                        <div className="mb-4 row align-items-center">
                          <label className="col-sm-3 col-form-label form-label-title">
                            Ignore expiry date
                          </label>
                          <div className="col-sm-9">
                            <label className="switch" style={{position: 'relative', display: 'inline-block', width: '60px', height: '34px'}}>
                              <input
                                type="checkbox"
                                checked={ignoreExpiry}
                                onChange={(e) => {
                                  setIgnoreExpiry(e.target.checked);
                                  if (e.target.checked) {
                                    setFormData((prev) => ({
                                      ...prev,
                                      mfd_date: "",
                                      exp_date: "",
                                    }));
                                  }
                                }}
                                style={{opacity: 0, width: 0, height: 0, border: "2px solid #0da486b9"}}
                              />
                              <span className="switch-state" style={{
                                position: 'absolute',
                                cursor: 'pointer',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: ignoreExpiry ? '#0da487' : '#ccc',
                                transition: '.4s',
                                borderRadius: '34px',
                                border: "2px solid #0da486b9"
                              }}>
                                <span style={{
                                  position: 'absolute',
                                  content: '',
                                  height: '26px',
                                  width: '26px',
                                  left: ignoreExpiry ? '30px' : '4px',
                                  bottom: '4px',
                                  backgroundColor: 'white',
                                  transition: '.4s',
                                  borderRadius: '50%'
                                }}></span>
                              </span>
                            </label>
                          </div>
                        </div>

                        {!ignoreExpiry && (
                          <>
                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">
                                MFD date
                              </label>
                              <div className="col-sm-9">
                                <input
                                  className="form-control"
                                  type="date"
                                  name="mfd_date"
                                  value={formData.mfd_date}
                                  onChange={handleInputChange}
                                  required
                                  max={today}
                                  style={{ border: "2px solid #0da486b9" }}
                                />
                              </div>
                            </div>

                            <div className="mb-4 row align-items-center">
                              <label className="form-label-title col-sm-3 mb-0">
                                EXP date
                              </label>
                              <div className="col-sm-9">
                                <input
                                  className="form-control"
                                  type="date"
                                  name="exp_date"
                                  value={formData.exp_date}
                                  onChange={handleInputChange}
                                  required
                                  min={formData.mfd_date || today}
                                  style={{ border: "2px solid #0da486b9" }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {/* Booking Quantity */}
                    {/* <div className="mb-4 row align-items-center">
                      <label className="form-label-title col-sm-3 mb-0">
                        Booking quantity
                      </label>
                      <div className="col-sm-9">
                        <input
                          className="form-control"
                          type="number"
                          name="booking_quantity"
                          value={formData.booking_quantity}
                          onChange={handleInputChange}
                          required
                          min="0"
                        />
                      </div>
                    </div> */}

                    {/* Quantity */}
                    <div className="mb-4 row align-items-center">
                      <label className="form-label-title col-sm-3 mb-0">
                        Quantity
                      </label>
                      <div className="col-sm-9" >
                        <input
                          className="form-control"
                          type="number"
                          name="quantity"
                          value={formData.quantity}
                          onChange={handleInputChange}
                          required
                          min="0"
                          style={{ border: "2px solid #0da486b9" }}
                        />
                      </div>
                    </div>

            <div className="mt-5 mb-4">
                <button
                  className="btn btn-animation"
                  type="submit"
                  disabled={addstockIsPending}
                  style={{
                    opacity: addstockIsPending ? 0.6 : 1,
                    cursor: addstockIsPending ? "not-allowed" : "pointer"
                  }}
                >
                  {addstockIsPending ? "Submitting..." : "Submit"}
                </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
